<template>
  <div class="password-policy-checklist text-body-2 ma-2 mt-4" role="list" aria-label="Requisitos de la contraseña">
    <div
      v-for="row in rows"
      :key="row.key"
      class="password-policy-checklist__row d-flex align-center"
      :class="row.met ? 'text-success' : 'text-error'"
      role="listitem"
    >
      <v-icon :icon="row.met ? iconCheck : iconClose" size="18" class="mr-2 flex-shrink-0" />
      <span>{{ row.label }}</span>
    </div>
  </div>
</template>

<script>
import icons from '../../utils/enums/icons'
import { evaluatePasswordPolicy, PASSWORD_POLICY_ITEMS } from '../../utils/helpers/passwordPolicy'

export default {
  name: 'PasswordPolicyChecklist',
  props: {
    password: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      iconCheck: icons.CHECK,
      iconClose: icons.CLOSE,
    }
  },
  computed: {
    policy() {
      return evaluatePasswordPolicy(this.password)
    },
    rows() {
      return PASSWORD_POLICY_ITEMS.map((item) => ({
        ...item,
        met: !!this.policy[item.key],
      }))
    },
  },
}
</script>

<style scoped>
.password-policy-checklist__row + .password-policy-checklist__row {
  margin-top: 4px;
}
</style>
